import React from "react";
import PropTypes from "prop-types";
import { Modal, ModalBody } from "reactstrap";
import { imageURl } from "../../libs/env";

const SampleReportModal = ({ isOpen, toggle }) => {
  return (
    <Modal
      isOpen={isOpen}
      size="lg"
      toggle={toggle}
      className="modal-dialog-centered"
      backdrop="static"
    >
      <ModalBody className="p-4">
        <div class="row align-items-start">
          <div class="col-10">
            <h3 class="text-dark text-start fs-5">
              <strong className="ps-1">
                Sample AI writing report
              </strong>
            </h3>
            <p class="text-dark my-3 text-start">
                After every submission by a student, a report is generated and can be viewed by the student and the teacher. 
            </p>
          </div>
          <div class="col-2 text-end">
            <button onClick={() => {if(sessionStorage.getItem("showCancel"))
                  {
                    toggle();
                    sessionStorage.removeItem("showCancel");
                  }
                  else {
                    toggle();
                  }
                  }} className="btn p-0 me-2 ">
              <img src={`${imageURl}/close.png`} width="17px" alt="Cross img" />
            </button>
          </div>
        </div>
        <div className="col-12">
          <img src={`${imageURl}/quizy_writing_rpt.png`} alt=""/>
        </div>
      </ModalBody>
    </Modal>
  );
};

SampleReportModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};

SampleReportModal.defaultProps = { isOpen: false };

export default SampleReportModal;
